import React from 'react';
import { useTranslations } from 'next-intl';

import { proConst, useStoreItem } from 'modules/pro';

import Card from './cards';

export const SocialMedias = () => {
  const t = useTranslations();
  const storeItem = useStoreItem();

  return (
    <div className="my-20 px-3">
      <div className="text-center text-2xl font-bold text-gray-800">{t('ijtimoiy_tarmoqlar')}</div>
      <div className="mt-8.5 grid sm:grid-cols-4 gap-4 grid-cols-2">
        {proConst.baseSocialMedias.map(item => (
          <Card item={item} key={item.url} />
        ))}
        {storeItem ? <Card item={storeItem} /> : <div className="h-51 animate-pulse rounded-2xl bg-gray-200" />}
      </div>
    </div>
  );
};
